<script>
import { useAuthStore } from "@/stores/auth-store";
import { getAuthHostName } from "@/utils/urls";

export default {
  data() {
    return {
      authUrl: getAuthHostName(),
    };
  },
  setup() {
    const authStore = useAuthStore();
    return {
      authStore,
    };
  },
  methods: {
    handleLogout() {
      this.authStore.logout();
      this.$router.push("/login");
    },
  },
};
</script>
<template>
  <div class="dropdown profile-dropdown" v-show="authStore.currentUser">
    <a
      href="javascript:void(0);"
      class="d-flex align-items-center"
      data-bs-toggle="dropdown"
    >
      <span class="avatar">
        <img
          :src="`${authUrl}/storage/photo/${authStore.currentUser.photo}`"
          alt="Img"
          class="img-fluid rounded-circle"
        />
      </span>
    </a>
    <div class="dropdown-menu dropdown-menu-end">
      <div class="profile-header d-flex align-items-center">
        <div class="avatar">
          <img
            :src="`${authUrl}/storage/photo/${authStore.currentUser.photo}`"
            alt="Img"
            class="img-fluid rounded-circle"
          />
        </div>
        <div>
          <h6>{{ authStore.currentUser.nickname }}</h6>
          <p>{{ authStore.currentUser.email }}</p>
        </div>
      </div>
      <ul class="profile-body">
        <li>
          <router-link
            class="dropdown-item d-inline-flex align-items-center rounded fw-medium"
            :to="
              authStore.role === 'principal'
                ? '/principal/profile'
                : authStore.role === 'instructor'
                ? '/instructor/instructor-profile'
                : '/students/student-profile'
            "
            ><i class="isax isax-security-user me-2"></i>My Profile</router-link
          >
          <!-- '/instructor/instructor-profile' -->
        </li>
        <!-- <li>
                  <router-link
                    class="dropdown-item d-inline-flex align-items-center rounded fw-medium"
                    to="/instructor/instructor-course"
                    ><i class="isax isax-teacher me-2"></i>Courses</router-link
                  >
                </li>
                <li>
                  <router-link
                    class="dropdown-item d-inline-flex align-items-center rounded fw-medium2"
                    to="/instructor/instructor-earnings"
                    ><i class="isax isax-dollar-circle me-2"></i
                    >Earnings</router-link
                  >
                </li>
                <li>
                  <router-link
                    class="dropdown-item d-inline-flex align-items-center rounded fw-medium"
                    to="/instructor/instructor-payout"
                    ><i class="isax isax-coin me-2"></i>Payouts</router-link
                  >
                </li>
                <li>
                  <router-link
                    class="dropdown-item d-inline-flex align-items-center rounded fw-medium"
                    to="/instructor/instructor-message"
                    ><i class="isax isax-messages-3 me-2"></i>Messages<span
                      class="message-count"
                      >2</span
                    ></router-link
                  >
                </li>
                <li>
                  <router-link
                    class="dropdown-item d-inline-flex align-items-center rounded fw-medium"
                    to="/instructor/instructor-settings"
                    ><i class="isax isax-setting-2 me-2"></i
                    >Settings</router-link
                  >
                </li> -->
      </ul>
      <div class="profile-footer">
        <!-- <router-link
                  class="dropdown-item d-inline-flex align-items-center rounded fw-medium"
                  to="/"
                  ><i class="isax isax-arrow-2 me-2"></i>Log in as
                  Student</router-link
                > -->
        <button
          @click="handleLogout"
          class="btn btn-secondary d-inline-flex align-items-center justify-content-center w-100"
        >
          <i class="isax isax-logout me-2"></i>
          Logout
        </button>
      </div>
    </div>
  </div>
</template>
